<form class="form-inline subscribeForm mt-2" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
    <div class="form-group" >
        <mat-form-field appearance="outline">
            <mat-label>您用來接收Trinka新聞的電子郵件</mat-label>
            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
        </mat-form-field>
    </div>
    <div class="btn-group">
        <button type="submit" class="filled-btn" [disabled]="!footerFroms.valid">訂閱</button>
    </div>
</form>

<div class="modal fade" id="emailSubscribePopup" tabindex="-1" role="dialog" aria-labelledby="subscribeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="btn-close" (click)="dismissSubcribePopup()" data-dismiss="modal"></button>
            <h3 class="text-center">Thank you for subscribing to our newsletter</h3>
            <p>Your subscription has been confirmed.</p>
            <div class="btn-group justify-content-center mt-2">
                <button type="button" class="filled-btn" (click)="dismissSubcribePopup()" data-dismiss="modal">OK</button>
            </div>
            <small>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</small>
        </div>
      </div>
    </div>
</div>